
export default {
  name: "Category",
};
